import React from 'react'
import { Box } from '@mui/material'
import { TariffChart } from 'src/Libs/e-mobility/tariffs/components/tariff-details/tariff-chart/TariffChart'
import { MOCK_DYNAMIC_TARIFF } from '../../mock-data/mock-dynamic-tariff'
import { tariffDetailsDtoToModel } from 'src/Libs/e-mobility/tariffs/transformers/single-tariff-dto-to-model'
import { Trans } from 'react-i18next'

/** Single tariff details step with dynamic tariff details pop-up */
export const DynamicTariffDetailsStep: React.FC = () => {
  return (
    <>
      <Trans i18nKey="emobility.tour.tariff-dynamic-dialog" components={{ strong: <strong /> }} />

      <Box mt={2}>
        <TariffChart tariff={tariffDetailsDtoToModel(MOCK_DYNAMIC_TARIFF, true)} height={150} />
      </Box>
    </>
  )
}
